import { TAB_ORDER, MY_ADS_TEST_IDS, myAdsTestId } from '../../utils';
import { loadingStateStyles } from './loading-state.styles';
import type { TLoadingStateConfig } from './loading-state.types';

const LoadingState = ({ showTabs = true, showList = true }: TLoadingStateConfig) => (
	<div data-testid={MY_ADS_TEST_IDS.LOADING_STATE}>
		{showTabs && (
			<div className={loadingStateStyles.tabsRow} data-testid={MY_ADS_TEST_IDS.LOADING_TABS}>
				{TAB_ORDER.map((tabId, index) => (
					<div
						key={tabId}
						className={loadingStateStyles.tabSkeleton(index)}
						data-testid={myAdsTestId.loadingTabSkeleton(index)}
						aria-hidden="true"
					/>
				))}
			</div>
		)}
		{showList && (
			<div className={loadingStateStyles.listContainer}>
				{[1, 2, 3].map((i) => (
					<div
						key={i}
						className={loadingStateStyles.cardSkeleton}
						data-testid={myAdsTestId.loadingSkeleton(i)}
						aria-hidden="true"
					/>
				))}
			</div>
		)}
	</div>
);

LoadingState.displayName = 'LoadingState';

export { LoadingState };
